// Does this report have a vehicle equipment question the client could answer?
// Derived from the ADAS services exactly like the "Requires Attention" card on the
// report page: a service still 'potential' (not removed) is an open question. The
// stored subStatus is NOT used — it can go stale (dev #175 sat on 'needs-attention'
// with no services at all), and a tag with nothing behind it would mislead.
export const hasOpenQuestion = report => {
  const services = (report && report.adas && report.adas.services) || []
  return services.some(s => s && s.recommendedStatus === 'potential')
}

// Show the tag only when there is an open question AND the report's own client is
// allowed to answer it (answerByClient comes from the list response, keyed by
// client id) — otherwise the tag would point at something the client cannot act on.
export const showNeedsAttention = (report, answerByClient = {}) => {
  if (!hasOpenQuestion(report)) return false
  const client = report.client && (report.client._id || report.client)
  if (!client) return false
  return answerByClient[String(client)] === true
}

export default showNeedsAttention
